<template>
  <div class="order-item-warp" @click="orderDetails">
    <div class="order-item-main">
      <div class="order-item-title">
        <span>{{typeMap[item.pZujie]}}</span>
        <span v-if="item.pAlipayjsSm && item.pAlipayjsSm === '代扣支付失败'" class="unpay">{{ i18n.unpay }}</span>
      </div>
      <p><span class="text-info">{{i18n.order_number}}</span>{{item.pOrderid}}</p>
      <p><span class="text-info">{{i18n.time_rented}}</span>{{item.pBorrowtime | dateFmt}}</p>
      <p><span class="text-info">{{i18n.venue_rented}}</span>{{item.pShopName}}</p>
    </div>
    <div class="order-item-foot" v-if="!isZujie">
      <div>
        <img src="../../assets/imgs/icon_time.png" alt="">
        <span>{{item.pUseMins}} {{i18n.min}}</span>
      </div>
      <div>
        <!-- <img src="../../assets/imgs/icon_money.png" alt=""> -->
        <span class="circlesign">{{ currencyName }}</span>
        <span>{{$moneyFormat(item.pJiesuan)}} {{currency}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import i18n from "../../i18n";
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters(["locale"]),
    i18n() {
      return this.$t("order_item")
    },
    isZujie() {
      return (
        this.item.pJiesuanid === 0 &&
        (this.item.pZujie === 1 || this.item.pZujie === 4)
      )
    },
    currencyName () {
      return this.item.pCurrencyName || this.locale.money
    }
  },
  data() {
    return {
      typeMap: {}
    }
  },
  methods: {
    onSubmit() {
      this.$router.push({
        path: "/confirm",
        query: {
          price: this.item.pJiesuan,
          payType: "FK",
          outTradeNo: this.item.pOrderid,
          cabinetID: this.item.pCabinetid
        }
      })
    },
    // 订单详情
    orderDetails() {
      this.$router.push(`/order/${this.item.porderid}`)
    },
    // 格式化时间
    orderDateFmt(seconds = 0) {
      let hours = Number.parseInt(seconds / 3600)
      let minutes = Number.parseInt((seconds - hours * 3600) / 60)
      let second = Number.parseInt(seconds - hours * 3600 - minutes * 60)
      second = second < 10 ? "0" + second : second
      hours = hours < 10 ? "0" + hours : hours
      minutes = minutes < 10 ? "0" + minutes : minutes
      return `${hours}:${minutes}:${second}`
    },
    // 订单时长
    orderDuration(item) {
      let seconds = item.puseMins * 60
      if (item.puseMins === 0 && item.pZujie === 1) {
        const nT = Date.now() - 8 * 3600 * 1000
        const bT = new Date(item.pborrowtime).getTime()
        seconds = parseInt((nT - bT) / 1000)
      }
      return this.orderDateFmt(seconds)
    }
  },
  created() {
    this.typeMap = {
      0: this.i18n.type_0,
      1: this.i18n.type_1,
      2: this.i18n.type_2,
      3: this.i18n.type_3,
      4: this.i18n.type_4,
      5: this.i18n.type_5
    }
  }
}
</script>

<style lang="less" scoped>
.order-item-warp + .order-item-warp {
  margin-top: 40px;
}
.order-item-warp {
  background-color: #fff;
  padding: 0 24px;
  border-radius: 20px;
  color: #000;
  font-size: 24px;
  font-family: 'Montserrat-Regular';
  line-height: 40px;
  box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.2);
  .text-info {
    color: #999;
  }
  .order-item-main {
    padding: 40px 24px 1px;
    p {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .order-item-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 32px;
    color: #999;
    font-family: 'Montserrat-Medium';
  }
  .unpay {
    font-size: 30px;
    background: #FF00FF;
    color: #fff;
    border-radius: 10px;
    padding: 10px 20px;
  }
  .order-item-foot {
    display: flex;
    justify-content: flex-start;
    border-top: 2px dashed #707070;
    padding: 0 24px;
    font-weight: bold;
    font-size: 28px;
    div {
      height: 80px;
      width: 50%;
      flex: 1;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    img {
      height: 36px;
      width: 36px;
      margin-right: 20px;
    }
    .circlesign{
      height: 36px;
      width: 36px;
      line-height: 36px;
      text-align: center;
      margin-right: 20px;
      border: solid 1px #F08224;
      color: #F08224;
      border-radius: 100%;
    }
  }
}
</style>
